<template>
	<div id="pageRoot">

		<p class="textBase appearAnimationB" id="text01" style="z-index: 6">
			Venancio aprendió a volar con la ayuda de don Fito.
		</p>
		<p class="textBase appearAnimationB" id="text02" style="z-index: 6">
			Primero aprendió a saltar del suelo hasta
		</p>
		<p class="textBase appearAnimationB" id="text03" style="z-index: 6">
			Luego del suelo al techo
		</p>
		<p class="textBase appearAnimationB" id="text04" style="z-index: 6">
			Saltaba cada vez más alto. ¡Daba media
		</p>
		<p class="textBase appearAnimationB" id="text05" style="z-index: 6">
			Finalmente aprendió a volar. Así voló dos
		</p>

		<div class="text-box-a hover-animation-a" id="textBox01" style="z-index: 5">
			<p class="textBase" id="textBox01Text">
				Ahora lee el texto.
			</p>
		</div>


		<saved-input v-bind:page="$parent.page" v-bind:type="$parent.type" number=1 id="inputField01" ref="i01" class="pageElement" style=
		"z-index: 7"/>
		<saved-input v-bind:page="$parent.page" v-bind:type="$parent.type" number=2 id="inputField02" ref="i02" class="pageElement" style=
		"z-index: 7"/>
		<saved-input v-bind:page="$parent.page" v-bind:type="$parent.type" number=3 id="inputField03" ref="i03" class="pageElement" style=
		"z-index: 7"/>
		<saved-input v-bind:page="$parent.page" v-bind:type="$parent.type" number=5 id="inputField05" ref="i04" class="pageElement" style=
		"z-index: 7"/>

		<!-- FONDO SVG ----------------------------------------------------------------------------------------------------->
		<img id="fixed" src="/pages/img/sordo/svgPage83Fixed.svg">
		<span class="footer-page footer-read"></span>
		<!-- FONDO SVG ----------------------------------------------------------------------------------------------------->
	</div>
</template>
<style scoped>
#fixed
{
position: absolute;
width: 870.02px;
height: 572px;
left: 41px;
top: 32px;
}
#text01
{
position: absolute;
width: 594px;
height: 35px;
left: 26px;
top: 144px;
}
#text02
{
position: absolute;
width: 594px;
height: 35px;
left: 20px;
top: 241px;
}
#text03
{
position: absolute;
width: 594px;
height: 35px;
left: 26px;
top: 328px;
}
#text04
{
position: absolute;
width: 443px;
height: 35px;
left: 26px;
top: 415px;
}
#text05
{
position: absolute;
width: 499px;
height: 35px;
left: 26px;
top: 502px;
}
#textBox01
{
position: absolute;
width: 622.65px;
height: 90.25px;
left: 171px;
top: 633.17px;
background-image: url(/pages/img/sordo/svgPage83Textbox01.svg);
}
#textBox01Text
{
position: absolute;
width: 510px;
height: 58px;
left: 34.58px;
top: 19.84px;

font-size: 36px;
line-height: 49px;
text-align: center;

color: #FBF8F8;
}
#inputField01
{
position: absolute;
width: 349px;
height: 48px;
left: 516px;
top: 208px;

font-size: 33px;
}
#inputField02
{
position: absolute;
width: 507px;
height: 48px;
left: 358px;
top: 300px;

font-size: 33px;
}
#inputField03
{
position: absolute;
width: 369px;
height: 48px;
left: 496px;
top: 390px;

font-size: 33px;
}
#inputField04
{
position: absolute;
width: 815px;
height: 48px;
left: 50px;
top: 411px;

font-size: 33px;
}
#inputField05
{
position: absolute;
width: 341px;
height: 48px;
left: 524px;
top: 477px;

font-size: 33px;
}
#inputField06
{
position: absolute;
width: 815px;
height: 48px;
left: 50px;
top: 550px;

font-size: 33px;
}
</style>

<script>
export default {
data() {
		return {
			videos: ["p84-85/V103.mp4"] 
		};
	},

computed: {
dbId01(){
return `${this.$parent.type}-${82}-${1}`
},
dbId02(){
return `${this.$parent.type}-${82}-${2}`
},    
dbId03(){
return `${this.$parent.type}-${83}-${1}`
},    
dbId04(){
return `${this.$parent.type}-${83}-${2}`
}          
},
async created() {

var value01 = await this.$db.inputs.get({
id: this.dbId01,
}).catch(function(error){
console.log("error getting option 1" + error);
});
var value02 = await this.$db.inputs.get({
id: this.dbId02,
}).catch(function(error){
console.log("error getting option 2 " + error);
});
var value03 = await this.$db.inputs.get({
id: this.dbId03,
}).catch(function(error){
console.log("error getting option 3" + error);
});
var value04 = await this.$db.inputs.get({
id: this.dbId04,
}).catch(function(error){
console.log("error getting option 4" + error);
});
if (value01 != undefined) {
	console.log(value01);
	this.$refs.i01.$refs.input.value = value01.text;
}
if (value02 != undefined) {
	console.log(value02);
	this.$refs.i02.$refs.input.value = value02.text;
}
if (value03 != undefined) {
	console.log(value03);
	this.$refs.i03.$refs.input.value = value03.text;
}
if (value04 != undefined) {
	console.log(value04);
	this.$refs.i04.$refs.input.value = value04.text;
}
},
}
</script>